<section class="background-color integration u-padding-16">
  <header class="integration__header line-height-24 u-font-size-16">
    {{template?.name}}
    <span class="integration__active">
      <mat-chip-list>
        <mat-chip color="primary">
          <mat-icon class="circle-icon {{getActiveIconClass()}}">circle</mat-icon>
          {{getActiveIconText()}}
        </mat-chip>
      </mat-chip-list>
    </span>
    <div class="integration__subheader line-height-16 u-font-size-14">
      <a href="{{template?.website}}" target="_blank">Helpdesk</a>
    </div>
  </header>
  <div class="integration__content border-color background-color-intense u-margin-top-20 u-margin-bottom-8">
    <form class="o-flex o-flex--column u-margin-bottom-m" [formGroup]="integrationForm">
      <span class="integration__longlabel">
        Please enter the email that you currently use for Cardioworld purchases, or the one that you will use in future
      </span>
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="CardioWorld purchases email address" required/>
        <mat-error *ngIf="integrationForm.get('email')?.hasError('required')">
          Email address is required
        </mat-error>
        <mat-error *ngIf="integrationForm.get('email')?.hasError('email')">
          Invalid email address
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <div *ngIf="showDiscountCoupons()" class="integration__discounts">
    <header class="integration__header line-height-24 u-font-size-16">
      Discount coupons
      <div class="integration__subheader line-height-16 u-font-size-14">
        <span>The coupons below can be used on the Cardioworld shop for the specified discounts.</span>
      </div>
    </header>
    <div class="integration__coupons">
      <div class="integration__coupon integration__coupon--header">
        <div class="integration__coupon-cell integration__coupon-cell--code">
          <span>contact@cardioworld.de</span>
        </div>
        <div class="integration__coupon-cell integration__coupon-cell--discount">
          <span>FREE</span>
        </div>
        <div class="integration__coupon-cell integration__coupon-cell--condition">
          <span>
            Pro Kit Starter Bundle (Lactate meter, hardcase, calibration solution, lancets, etc) with ordering 36 Boxes of strips (first time customers only)
          </span>
        </div>
      </div>
      <div class="integration__coupon" *ngFor="let item of coupons">
        <div class="integration__coupon-cell integration__coupon-cell--code">
          <kbd>{{item.code}}</kbd>
        </div>
        <div class="integration__coupon-cell integration__coupon-cell--discount">
          <span>{{item.discount_percent}}% off</span>
        </div>
        <div class="integration__coupon-cell integration__coupon-cell--condition">
          <span *ngIf="item.condition">for {{item.condition}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="integration__buttons">
    <button mat-raised-button color="primary" [disabled]="!canSave()" (click)="save()">{{getSaveButtonText()}}</button>
    <button mat-raised-button *ngIf="showIntegrationActiveFlag$.value" (click)="toggleActivation()">{{getToggleActivationButtonText()}}</button>
  </div>
</section>
